import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import StepLayout from '../../components/StepLayout/StepLayout';
import PhoneInputField from '../../components/PhoneInputField/PhoneInputField';
import { useTunnelDispatch, useTunnelState } from '../../context/TunnelContext';
import { isEmailValid, isPhoneValid } from '../../utils/validation';

export default function ClientInfoForm() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { shoes, client } = useTunnelState();
  const [form, setForm] = useState(client);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (shoes.length === 0) {
      navigate('/nouvelle-demande/marque', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChange(field) {
    return (event) => setForm({ ...form, [field]: event.target.value });
  }

  function handlePhoneChange(phone) {
    setForm({ ...form, phone });
  }

  function validate() {
    const nextErrors = {};
    if (!form.familyName.trim()) nextErrors.familyName = 'Champ requis';
    if (!form.givenName.trim()) nextErrors.givenName = 'Champ requis';
    if (!form.email.trim()) {
      nextErrors.email = 'Champ requis';
    } else if (!isEmailValid(form.email)) {
      nextErrors.email = 'Adresse e-mail invalide';
    }
    if (!form.phone.trim()) {
      nextErrors.phone = 'Champ requis';
    } else if (!isPhoneValid(form.phone)) {
      nextErrors.phone = 'Numéro de téléphone invalide';
    }
    return nextErrors;
  }

  function handleSubmit(event) {
    event.preventDefault();
    const nextErrors = validate();
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      toast.error('Veuillez corriger les champs indiqués.');
      return;
    }
    dispatch({ type: 'SET_CLIENT', client: form });
    navigate('/nouvelle-demande/recapitulatif-commande');
  }

  return (
    <StepLayout title="Vos coordonnées">
      <Stack
        component="form"
        onSubmit={handleSubmit}
        spacing={3}
        sx={{ maxWidth: 480 }}
      >
        <TextField
          label="Nom"
          value={form.familyName}
          onChange={handleChange('familyName')}
          error={Boolean(errors.familyName)}
          helperText={errors.familyName}
          required
        />
        <TextField
          label="Prénom"
          value={form.givenName}
          onChange={handleChange('givenName')}
          error={Boolean(errors.givenName)}
          helperText={errors.givenName}
          required
        />
        <TextField
          label="E-mail"
          type="email"
          value={form.email}
          onChange={handleChange('email')}
          error={Boolean(errors.email)}
          helperText={errors.email}
          required
        />
        <PhoneInputField
          value={form.phone}
          onChange={handlePhoneChange}
          error={errors.phone}
        />
        <Button type="submit" variant="contained" size="large">
          Continuer
        </Button>
      </Stack>
    </StepLayout>
  );
}
